import React from "react";
import { FormattedMessage } from "react-intl";

export const FeedbackPage: React.FC = () => {
  return (
    <div>
      <FormattedMessage id='FeedbackPage.header' />
    </div>
  );
};

export default FeedbackPage;
